import classNames from 'classnames'
import { omit, pick } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import ThumbnailSelectable from 'components/ThumbnailSelectable'

import styles from './ThumbnailsMultipleSelectable.module.scss'

export default class ThumbnailsMultipleSelectable extends React.Component {
  static propTypes = {
    active: PropTypes.object,
    className: PropTypes.string,
    thumbnails: PropTypes.object,
    onThumbnailSelect: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      active: props.active || {},
    }
  }

  handleClick = (imageId) => {
    const { onThumbnailSelect, thumbnails } = this.props
    const { active } = this.state

    const items = !active[imageId] ?
      {
        ...active,
        ...pick(thumbnails, [imageId]),
      } : omit(active, [imageId])

    this.setState({ active: items })

    if (onThumbnailSelect) onThumbnailSelect(items)
  }

  render() {
    const { className, thumbnails } = this.props
    const { active } = this.state

    return (
      <div
        uk-grid="true"
        className={classNames('ThumbnailsMultipleSelectable', 'uk-grid-small', styles.this, className)}>
        {Object.keys(thumbnails).map((thumbnailId) => {
          const thumbnail = thumbnails[thumbnailId]

          return (
            <div key={thumbnailId}>
              <ThumbnailSelectable
                active={active[thumbnailId] ? true : false}
                //image={thumbnail.imageUrl}
                image={thumbnail.imageRef}
                onClick={() => this.handleClick(thumbnailId)}
              />
            </div>
          )
        })}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ThumbnailsMultipleSelectable/ThumbnailsMultipleSelectable.js